import { siteNav } from "@/mocks/homeData";

export default function QuickAccess() {
  return (
    <section id="quick-access" className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            快速访问入口
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm md:text-base">
            以下所有地址均经过验证，确保安全可靠。建议收藏本页以便随时获取
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          <div className="p-6 rounded-2xl bg-background-50 border border-primary-200/60">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-star-fill text-lg"></i>
              </span>
              <div>
                <h3 className="font-semibold text-foreground-900">官方主入口</h3>
                <p className="text-xs text-foreground-500">推荐使用 · 最高优先级</p>
              </div>
            </div>
            <div className="bg-background-100 rounded-xl p-4 mb-4">
              <p className="text-sm font-mono text-foreground-700 break-all">{siteNav.officialUrl}</p>
            </div>
            <a
              href={siteNav.officialUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-full inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
              立即访问
            </a>
          </div>

          <div className="p-6 rounded-2xl bg-background-50 border border-accent-200/60">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-500 text-background-50">
                <i className="ri-stack-line text-lg"></i>
              </span>
              <div>
                <h3 className="font-semibold text-foreground-900">备用访问地址</h3>
                <p className="text-xs text-foreground-500">3条线路 · 互为备份</p>
              </div>
            </div>
            <div className="space-y-2 mb-4">
              {siteNav.backupUrls.map((backup, index) => (
                <div key={index} className="flex items-center justify-between bg-background-100 rounded-xl px-4 py-3">
                  <div className="flex items-center gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-xs font-semibold">
                      {index + 1}
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">{backup.label}</p>
                      <p className="text-sm font-mono text-foreground-700">{backup.url}</p>
                    </div>
                  </div>
                  <a
                    href={backup.url}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 hover:bg-accent-200 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}